import React, { useEffect } from 'react';
import { Box } from '@mui/system';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'moment';
import { IconButton } from '@mui/material';
import { SaveAlt } from '@mui/icons-material';
import { ICustomFirmwareFile } from '../../../types/firmwareVersions/firmwareVersionsInterface';
import { useGetUpgradeTypesMutation } from '../../../services/firmwareVersions/firmwareVersionsService';
import { useGetAllProductNamesMutation } from '../../../services/device/deviceService';

interface CustomFirmwareFilesListProps {
  files: ICustomFirmwareFile[];
  selectedFiles: ICustomFirmwareFile[];
  setSelectedFiles: (selectedFiles: ICustomFirmwareFile[]) => void;
}
export const CustomFirmwareFilesList = ({
  files,
  selectedFiles,
  setSelectedFiles
}: CustomFirmwareFilesListProps) => {
  const [
    getUpgradeTypes,
    { isSuccess: successGetUpgradeTypes, data: dataUpgrade }
  ] = useGetUpgradeTypesMutation();

  const [
    getControllerTypes,
    { isSuccess: successGetControllerTypes, data: dataControllerTypes }
  ] = useGetAllProductNamesMutation();

  useEffect(() => {
    getUpgradeTypes();
    getControllerTypes('');
  }, []);

  const getUpgradeTypeByArray = (rowData: ICustomFirmwareFile) => {
    if (successGetUpgradeTypes && dataUpgrade) {
      const upgradeType = dataUpgrade.find(
        (item) => item.id === rowData.firmwareUpgradeTypeId
      );
      return upgradeType ? upgradeType.type : 'No information';
    }
    return 'No information';
  };

  const downloadCustomUrlIfExist = (rowData: ICustomFirmwareFile) => {
    return rowData.customUrl || rowData.fileUrl ? (
      <IconButton
        aria-label="save"
        href={
          rowData.customUrl ? rowData.customUrl ?? '' : rowData.fileUrl ?? ''
        }
        target="_blank"
        size="small"
      >
        <SaveAlt />
      </IconButton>
    ) : (
      <span className="font-italic fw-lighter">No information</span>
    );
  };
  return (
    <Box>
      <DataTable
        selection={selectedFiles}
        selectionMode="checkbox"
        onSelectionChange={(e) => {
          setSelectedFiles(e.value);
        }}
        value={files}
        size="small"
        scrollable
        paginator={files && files.length >= 50}
        selectionPageOnly
        rows={50}
        rowsPerPageOptions={[5, 10, 25, files ? files.length : 50]}
        tableStyle={{ fontSize: '14px' }}
      >
        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
        <Column
          field="createdAt"
          header="Created At"
          sortable
          body={(rowData: ICustomFirmwareFile) =>
            moment(rowData.createdAt).format('DD/MM/YYYY HH:mm A')
          }
        />
        <Column field="product.name" header="Product Type" sortable />
        <Column
          field="firmwareUpgradeType.type"
          header="Upgrade Type"
          sortable
          body={(rowData: ICustomFirmwareFile) =>
            rowData.firmwareUpgradeType.type
          }
        />
        <Column
          className="text-center"
          field="customUrl"
          header="Bin Url"
          sortable
          body={downloadCustomUrlIfExist}
        />
      </DataTable>
    </Box>
  );
};
